import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CereriComponent } from './cereri.component';
import { MaterialModule } from 'src/app/material.module';
import { DataTablesModule } from 'angular-datatables';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PipesModule } from 'src/app/pipes/pipes.module';
import { CereriDetaliiComponent } from './cereri-detalii/cereri-detalii.component';
import { SubsemnatComponent } from './cereri-detalii/subsemnat/subsemnat.component';
import { MesagerieComponent } from './cereri-detalii/mesagerie/mesagerie.component';
import { CerereDetaliiSabloaneComponent } from './cereri-detalii/sabloane/cerere-detalii-sabloane.component';
import { ActualizareCerereComponent } from './cereri-detalii/actualizare-cerere/actualizare-cerere.component';
import { ActiuniCerereCardComponent } from './cereri-detalii/actiuni-cerere-card/actiuni-cerere-card.component';
import { AddCerereComponent } from './add-cerere/add-cerere.component';
import { DocumenteCerereComponent } from './cereri-detalii/documente-cerere/documente-cerere.component';
import { IstoricCerereComponent } from './cereri-detalii/istoric-cerere/istoric-cerere.component';
import { InformatiiAditionaleComponent } from './cereri-detalii/informatii-aditionale/informatii-aditionale.component';
import { ModalInchidereLucrareComponent } from './cereri-detalii/modal-inchidere-lucrare/modal-inchidere-lucrare.component';
import { AddressComponent } from './cereri-detalii/subsemnat/address/address.component';
import { SpouseComponent } from './cereri-detalii/informatii-aditionale/spouse/spouse.component';


@NgModule({
    declarations: [
        CereriComponent,
        CereriDetaliiComponent,
        SubsemnatComponent,
        MesagerieComponent,
        CerereDetaliiSabloaneComponent,
        ActualizareCerereComponent,
        ActiuniCerereCardComponent,
        AddCerereComponent,
        DocumenteCerereComponent,
        IstoricCerereComponent,
        InformatiiAditionaleComponent,
        ModalInchidereLucrareComponent,
        AddressComponent,
        SpouseComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule,
        DataTablesModule,
        PipesModule
    ],
    exports: [CereriComponent],
})
export class CereriModule { }
